import React, { FC, memo } from 'react';

import IconFilterFilled from '@zvuk-b2b/react-uikit/ui/icons/FilterFilled';
import IconSearch from '@zvuk-b2b/react-uikit/ui/icons/Search';
import IconSortDescending from '@zvuk-b2b/react-uikit/ui/icons/SortDescending';

import { DATA_TEST_IDS } from '../../consts';
import { TEXTS } from '../../texts';

import styles from './index.module.scss';

const PromoSelectorSearchRow: FC = () => (
  <div
    className={styles.searchRow}
    data-testid={DATA_TEST_IDS.AUDIO_REPORT_PROMOS_TOOLBAR}>
    <div
      className={styles.search}
      data-testid={DATA_TEST_IDS.AUDIO_REPORT_PROMOS_SEARCH_CONTAINER}>
      <IconSearch className={styles.searchIcon} />
      <input
        className={styles.input}
        data-testid={DATA_TEST_IDS.AUDIO_REPORT_PROMOS_SEARCH}
        readOnly
        aria-label={TEXTS.AUDIO_REPORT_PROMOS_SEARCH_PLACEHOLDER}
        aria-readonly="true"
        placeholder={TEXTS.AUDIO_REPORT_PROMOS_SEARCH_PLACEHOLDER}
        value=""
      />
    </div>
    <button
      type="button"
      className={`${styles.control} ${styles.sortControl}`}
      data-testid={DATA_TEST_IDS.AUDIO_REPORT_PROMOS_SORT}
      aria-disabled="true"
      aria-label={TEXTS.AUDIO_REPORT_PROMOS_SORT_LABEL}
      title={TEXTS.AUDIO_REPORT_PROMOS_SORT_LABEL}>
      <span
        className={styles.sortIcon}
        data-testid={DATA_TEST_IDS.AUDIO_REPORT_PROMOS_SORT_ICON}
        aria-hidden="true">
        <IconSortDescending />
      </span>
    </button>
    <button
      type="button"
      className={`${styles.control} ${styles.filterControl}`}
      data-testid={DATA_TEST_IDS.AUDIO_REPORT_PROMOS_FILTER}
      aria-disabled="true"
      aria-label={TEXTS.AUDIO_REPORT_PROMOS_FILTER_LABEL}
      title={TEXTS.AUDIO_REPORT_PROMOS_FILTER_LABEL}>
      <span
        className={styles.filterIcon}
        data-testid={DATA_TEST_IDS.AUDIO_REPORT_PROMOS_FILTER_ICON}
        aria-hidden="true">
        <IconFilterFilled />
      </span>
    </button>
  </div>
);

export default memo(PromoSelectorSearchRow);
